module.exports = __webpack_public_path__ + "static/media/download.b0cf7ccb.svg";